<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import {coinList, getGameList, tenantinfo, getLanguageList} from '@/request/api.js'
  import {mutations, state} from '@/store.js'
  export default {
    name: 'App',
    watch: {
      '$i18n.locale': {
        handler() {
          this.getGameList();
          mutations.setLangStatus(this)
        },
        immediate: true
      }
    },
    async created() {
      await this.getLanguageList();
      await this.getCoinList();
      await this.getGameList();
    },
    methods: {
      getCoinList() {
        coinList().then(res => {
          if (res.code === 200) {
            mutations.changeCoinList(res.data)
          } else {
            // this.$message.error(error)
          }
        })
      },
      getGameList() {
        getGameList({
          ver: "1.0",
        }).then(res => {
          if (res.code == 200) {
            let data = res.data.gameList.filter(item => item.status);

            data.forEach((item) => {
              item.time = null;
              // item.isShowFullHashValue = false //是否显示完整的哈希值，只有10分，和5分链上才显示完整，其余区块显示缩写
              item.isLineBlockGame = false;
              item.alias = this.getGameNameBySubservicecode(
                item.gameName,
                this
              );
              if (/1M/.test(item.gameName)) {
                item.time = 1;
              }
              if (/3M/.test(item.gameName)) {
                item.time = 3;
              }
              if (/5M/.test(item.gameName) || item.gameName == "VNLOT") {
                item.time = 5;
                if (/MC/.test(item.gameName)) item.isLineBlockGame = true;
              }
              if (/TM/.test(item.gameName)) {
                item.time = 10;
                item.isLineBlockGame = true;
              }
            });
            console.log(data)
            mutations.changeGameList(data)
          } else {
            // res.msg && this.toast(res.msg);
          }
        })
      },
      getGameNameBySubservicecode(code, vueThis) {
        var name;
        switch (code) {
          case "VNLOT":
            name = vueThis.$t("version16.yn5mGameName");
            break;
          case "CRASH":
            name = vueThis.$t("version11.TS");
            break;
          case "BLK1M":
            name = vueThis.$t("version11.CQK1M");
            break;
          case "BLK3M":
            name = vueThis.$t("version18.CQK3M");
            break;
          case "BLK5M":
            name = vueThis.$t("version11.CQK5M");
            break;
          case "BLKTM":
            name = vueThis.$t("version11.CQK");
            break;
          case "RG1M":
            name = vueThis.$t("version11.HL");
            break;
          case "RG3M":
            name = vueThis.$t("version18.HL3M");
            break;
          case "RG5M":
            name = vueThis.$t("version11.HL5M");
            break;
          case "DS1M":
            name = vueThis.$t("version11.SD1M");
            break;
          case "DS3M":
            name = vueThis.$t("version18.SD3M");
            break;
          case "DS5M":
            name = vueThis.$t("version11.SD5M");
            break;
          case "DSTM":
            name = vueThis.$t("version12.SD10M");
            break;
          case "RGTM":
            name = vueThis.$t("version12.HL10M");
            break;
          case "LK1U":
            name = vueThis.$t("version13.YYYG");
            break;
          case "BLK5MC":
            name = vueThis.$t("version22.BLK5MC");
            break;
          case "RG5MC":
            name = vueThis.$t("version22.RG5MC");
            break;
          case "DS5MC":
            name = vueThis.$t("version22.DS5MC");
            break;
          case 'RD100N':
            name = vueThis.$t('version23.RD100N')
                break
          case 'SB1M':
            name = vueThis.$t('version23.SB1M')
              break
          case 'SB3M':
            name = vueThis.$t('version23.SB3M')
            break
          case 'SB5M':
            name = vueThis.$t('version23.SB5M')
            break
          case 'SBTM':
            name = vueThis.$t('version23.SBTM')
            break
          case 'MS':
            name = vueThis.$t('version24.MS')
            break
          case 'QT1M':
            name = vueThis.$t('version24.QT1M')
            break
          case 'QT3M':
            name = vueThis.$t('version24.QT3M')
            break
          case 'QT5M':
            name = vueThis.$t('version24.QT5M')
            break
          case 'QTTM':
            name = vueThis.$t('version24.QTTM')
            break
          case 'KN1M':
            name = vueThis.$t('version24.KN1M')
            break
          case 'KN3M':
            name = vueThis.$t('version24.KN3M')
            break
          case 'KN5M':
            name = vueThis.$t('version24.KN5M')
            break
          case 'KNTM':
            name = vueThis.$t('version24.KNTM')
            break

          case 'RLT1M':
            name = vueThis.$t('version24.RLT1M')
            break
          case 'RLT3M':
            name = vueThis.$t('version24.RLT3M')
            break
          case 'RLT5M':
            name = vueThis.$t('version24.RLT5M')
            break
          case 'RLTTM':
            name = vueThis.$t('version24.RLTTM')
            break

        }
        return name;
      },
      getTenantinfo() {
        tenantinfo().then(res => {
          if (res.code === 200) {
            mutations.changeSiteConfig(res.data)
            document.title = res.data.mobileTitle ?? window.location.origin
            let link =
                    document.querySelector("link[rel*='icon']") ||
                    document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "shortcut icon";
            link.href = res.data.webpageIco && res.data.webpageIco.startsWith('/') ? res.data.webpageIco : '/' + res.data.webpageIco;
            document.getElementsByTagName("head")?.[0]?.appendChild(link);
          }
        })
      },
      getLanguageList() {
        getLanguageList().then(res => {
          if (res.code === 200) {
            const filterArr = res.data.filter(item => {
              return item.status === 1
            });
            const arr = filterArr.sort((a,b) => {
              return a.sort - b.sort
            });
            mutations.setLangList(arr.map(item => {
              return {
                label: item.alias,
                code: item.lang,
              }
            }));
            const lang = localStorage.getItem('lang');
            const index = state.langList.findIndex(item => {
              return item.code === lang
            })
            const curNavLang = window.navigator.language
            console.log(curNavLang)
            const xxx = curNavLang.indexOf('-') == '-1' ? curNavLang : curNavLang.split('-').join('\\-');
            const reg = new RegExp('^[' + xxx + ']')
            console.log(reg)
            const navLangIndex = state.langList.findIndex(item => {
              return item.code === window.navigator.language || reg.test(item.code)
            })
            console.log(state.langList, 'state.langList')
            console.log(navLangIndex, 'navLangIndex')
            // 默认取本地记录的语言
            if (lang && !!~index) {
              mutations.setLang(lang, this)
            } else {
              // 默认取浏览器默认语言
              if (!!~navLangIndex) {
                mutations.setLang(state.langList[navLangIndex].code, this)
                console.log(navLangIndex, 'navLangIndex')
              } else {
                // 取语言列表第一个
                mutations.setLang(state.langList[0].code, this)
              }
            }
            this.getTenantinfo();
          } else {
            document.title = window.location.origin
          }
        }).catch(e => {
          if (e?.code === 40301) this.$message.error(this.$t('list.butigongfuwu'))
          if (e?.code === 444) this.$message.error(this.$t('version3.maintain'))
        })
      }
    }
  }
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
